<template>
  <div :class="$style.emoji">
    <ul :class="$style['emoji-controller']">
      <li
        v-for="(pannel, index) in pannels"
        :key="index"
        :class="index === activeIndex ? $style.active : ''"
        @click="changeActivePannel(index)"
      >
        {{ pannel }}
      </li>
      <i class="iconfont yw-jiantou9" @click="handleClose"></i>
    </ul>
    <ul :class="$style['emoji-container']">
      <li v-show="index === activeIndex" v-for="(emojiGroup, index) in emojiGroupArr" :key="index">
        <!-- 表情使用了雪碧图 -->
        <a
          v-for="(emoji, index) in emojiGroup"
          :key="index"
          href="javascript:;"
          @click="selectItem(emoji.replace(/:/g, ''))"
        >
          <span :title="emoji" :class="['emoji-item', 'sprite-' + getPureName(emoji)]"></span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import emojiData from '@/libs/emojidata.js'

export default {
  name: 'emoji',
  data() {
    return {
      emojiData: emojiData,
      pannels: ['表情', '自然', '物品', '地点', '符号'],
      activeIndex: 0
    }
  },
  computed: {
    emojiGroupArr() {
      return this.pannels.map(item => {
        return Object.keys(this.emojiData[item])
      })
    }
  },
  methods: {
    changeActivePannel(index) {
      this.activeIndex = index
    },
    handleClose() {
      this.$emit("close")
    },
    getPureName(name) {
      return name.replace(/:/g, '')
    },
    selectItem(emojiName) {
      this.$emit('selectEmoji', emojiName)
    },
  }
}
</script>
<style lang='scss' module>
.emoji {
  bottom: 30px;
  width: 100%;
  height: 186px;
  padding: 10px;
  background: #fff;
  overflow: hidden;
  .emoji-controller {
    width: 100%;
    height: 36px;
    display: flex;
    overflow: hidden;
    background: #fff;
    li {
      position: relative;
      width: 75px;
      font-size: 12px;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
    }
    .active::after {
      position: absolute;
      bottom: 4px;
      left: 6px;
      content: '';
      width: 80%;
      height: 1.5px;
      background: #0689dd;
    }
    i {
      line-height: 36px;
    }
  }
  .emoji-container {
    width: 100%;
    height: 140px;
    overflow-y: auto;
    overflow-x: hidden;
    li {
      a {
        float: left;
        overflow: hidden;
        height: 35px;
        transition: all ease-out 0.2s;
        border-radius: 4px;
        span {
          width: 25px;
          height: 25px;
          display: inline-block;
          border: 1px solid transparent;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
@import '~@/styles/emoji-eprite.scss';
</style>
